import { motion } from "framer-motion";
import { experience } from "../lib/data";

const Experience = () => {
  return (
    <section className="py-24 md:py-36" data-testid="experience">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 md:mb-20 gap-6">
          <div>
            <div className="section-label mb-6">© Experience</div>
            <h2 className="h-display text-5xl md:text-7xl lg:text-8xl">
              Digital <span className="italic font-serif">Craft.</span>
            </h2>
          </div>
          <p className="text-[color:var(--nn-muted)] max-w-md text-sm md:text-base leading-relaxed">
            A short list of the places I've called home — from Ahmedabad studios to Toronto product teams.
          </p>
        </div>

        <div>
          {experience.map((job, i) => (
            <motion.div
              key={job.company}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 }}
              className="group grid grid-cols-12 items-center gap-4 py-8 md:py-10 border-t border-[color:var(--nn-border)] hover:pl-4 transition-all duration-500"
              data-testid={`experience-${i}`}
            >
              <div className="col-span-2 md:col-span-1 font-mono text-xs text-[color:var(--nn-muted)]">
                0{i + 1}
              </div>
              <div className="col-span-10 md:col-span-4">
                <div className="font-serif text-3xl md:text-5xl tracking-tight">{job.company}</div>
                {job.current && (
                  <span className="inline-flex items-center gap-1.5 mt-2 font-mono text-[10px] uppercase tracking-widest text-[color:var(--nn-accent-text)]">
                    <span className="w-1.5 h-1.5 rounded-full bg-[color:var(--nn-accent)] animate-pulse" /> Current
                  </span>
                )}
              </div>
              <div className="col-span-6 md:col-span-3 text-sm md:text-base text-[color:var(--nn-text)]/80">
                {job.role}
              </div>
              <div className="col-span-6 md:col-span-2 text-sm text-[color:var(--nn-muted)]">
                {job.location}
              </div>
              <div className="col-span-12 md:col-span-2 md:text-right font-mono text-xs text-[color:var(--nn-muted)]">
                {job.period}
              </div>
            </motion.div>
          ))}
          <div className="border-t border-[color:var(--nn-border)]" />
        </div>
      </div>
    </section>
  );
};

export default Experience;
